// PrivacyPage.jsx
import React from "react";
import { LOOP_LEGAL_PRIVACY_VERSION, LOOP_LEGAL_UPDATED_LABEL, LOOP_SUPPORT_EMAIL } from "../utils/legalVersions";

const SECTIONS = [
  {
    "title": "1. Alcance",
    "body": "Esta Política de privacidad explica cómo Loop Reservas recopila, usa, protege y comparte información de clientes, negocios, administradores y trabajadores autorizados que usan la plataforma.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "2. Información que recopilamos",
    "body": "",
    "bullets": [
      "Datos de cuenta: nombre, apellido, correo, teléfono, fecha de nacimiento y credenciales de acceso cuando aplique.",
      "Datos de reserva: negocio, servicio, trabajador, fecha, hora, estado, notas operativas, ubicación o modalidad del servicio.",
      "Datos de negocio: perfil público, servicios, precios, horarios, trabajadores, permisos, clientes, inventario, reportes, membresías y fidelidad.",
      "Datos de pago: estado de pago, método, monto, propina, referencia, proveedor de pago, recibos y eventos de pago. Loop no debe almacenar datos completos de tarjeta.",
      "Datos técnicos: dispositivo, navegador, sistema operativo, logs, errores, IP aproximada, fuente de tráfico, sesión y eventos de uso."
    ],
    "callout": ""
  },
  {
    "title": "3. Cómo usamos la información",
    "body": "",
    "bullets": [
      "Crear y administrar cuentas.",
      "Gestionar reservas, confirmaciones, cancelaciones, recordatorios y soporte.",
      "Permitir que negocios operen agendas, clientes, trabajadores, reportes, inventario, pagos, membresías y fidelidad.",
      "Procesar o registrar pagos, anticipos, saldos, reembolsos, contracargos y conciliaciones cuando corresponda.",
      "Enviar comunicaciones operativas por email, WhatsApp, push u otros canales permitidos.",
      "Mejorar seguridad, prevenir fraude, diagnosticar errores y desarrollar nuevas funciones."
    ],
    "callout": ""
  },
  {
    "title": "4. Datos compartidos con negocios",
    "body": "Cuando reservas con un negocio, ese negocio puede acceder a los datos necesarios para atenderte: nombre, contacto, reserva, historial relacionado, pagos registrados, membresías, fidelidad y notas operativas. El negocio debe usar esos datos de forma responsable y conforme a sus obligaciones legales.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "5. Proveedores",
    "body": "Podemos usar proveedores de infraestructura, autenticación, base de datos, correo, mensajería, analítica, notificaciones, pagos y soporte. Estos proveedores procesan datos para operar Loop y no deben usarlos para fines propios no autorizados.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "6. Pagos",
    "body": "Los pagos online pueden ser procesados por terceros como Wompi u otros proveedores. Loop puede recibir referencias, estado del pago, monto, moneda, fecha, método y datos necesarios para conciliación. Los datos sensibles de tarjeta deben gestionarse por el proveedor de pago.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "7. Retención",
    "body": "Conservamos información mientras sea necesaria para operar cuentas, reservas, obligaciones legales, soporte, auditoría, seguridad, reportes del negocio y resolución de disputas. Algunos datos pueden conservarse aunque cierres tu cuenta si existe una obligación legal o comercial legítima.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "8. Seguridad",
    "body": "Aplicamos medidas técnicas y organizativas razonables para proteger la información. Ningún sistema es 100% infalible, por lo que también dependemos del uso responsable de contraseñas, permisos, dispositivos y accesos de trabajadores.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "9. Derechos y solicitudes",
    "body": "Puedes solicitar acceso, corrección, actualización, eliminación o revisión de tus datos escribiendo a soporte. Algunas solicitudes pueden requerir verificación de identidad y pueden estar limitadas por obligaciones legales, prevención de fraude o registros necesarios para reservas y pagos.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "10. Cambios",
    "body": "Podemos actualizar esta política cuando agreguemos funciones, proveedores, pagos, reportes, comunicaciones o requisitos legales. Si el cambio es material, podremos solicitar aceptación dentro de la app.",
    "bullets": [],
    "callout": ""
  }
];

function plainText() {
  return ["Loop Reservas — Política de privacidad.", `Versión: ${LOOP_LEGAL_PRIVACY_VERSION}`, `Actualización: ${LOOP_LEGAL_UPDATED_LABEL}`, "", ...SECTIONS.flatMap((section) => [section.title, section.body || "", ...(section.bullets || []).map((item) => `- ${item}`), section.callout ? `Nota: ${section.callout}` : "", ""]), `Contacto: ${LOOP_SUPPORT_EMAIL}`].filter((line, idx, arr) => line !== "" || arr[idx - 1] !== "").join("\n");
}

function downloadTextFile(filename, text) {
  try { const blob = new Blob([text], { type: "text/plain;charset=utf-8" }); const url = URL.createObjectURL(blob); const a = document.createElement("a"); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url); } catch (_) {}
}

const legalPageStyles = `
  .loop-legal-page { min-height: calc(100vh - 88px); background: radial-gradient(circle at 8% 0%, rgba(0,103,95,.12), transparent 30%), radial-gradient(circle at 92% 12%, rgba(251,247,239,.95), transparent 34%), linear-gradient(180deg,#fbfdfc 0%,#fff 48%,#f8fbfa 100%); padding: clamp(26px,4.5vw,68px) 18px 70px; color:#0b1220; box-sizing:border-box; }
  .loop-legal-wrap { width:min(1080px,100%); margin:0 auto; }
  .loop-legal-card { background:rgba(255,255,255,.94); border:1px solid rgba(207,225,222,.95); border-radius:34px; box-shadow:0 30px 90px rgba(15,23,42,.08); padding:clamp(26px,4vw,56px); overflow:hidden; }
  .loop-legal-topline { display:flex; align-items:flex-start; justify-content:space-between; gap:18px; margin-bottom:28px; }
  .loop-legal-kicker { color:#00675f; font-size:12px; font-weight:950; letter-spacing:.17em; text-transform:uppercase; margin-bottom:12px; }
  .loop-legal-title { margin:0; color:#0b1220; font-size:clamp(40px,5vw,68px); line-height:.96; letter-spacing:-.075em; font-weight:950; }
  .loop-legal-subtitle { margin:18px 0 0; color:#64748b; font-size:16px; line-height:1.65; font-weight:700; max-width:790px; }
  .loop-legal-version { flex:0 0 auto; border:1px solid rgba(0,103,95,.14); background:#f0fdfa; color:#00675f; border-radius:999px; padding:10px 13px; font-size:12px; font-weight:950; white-space:nowrap; }
  .loop-legal-actions { display:flex; flex-wrap:wrap; gap:9px; margin:24px 0 6px; }
  .loop-legal-actions button, .loop-legal-actions a { border:1px solid rgba(0,103,95,.16); background:#fff; color:#00675f; border-radius:999px; padding:10px 13px; font-size:12px; font-weight:950; text-decoration:none; cursor:pointer; }
  .loop-legal-actions .primary, .loop-legal-actions button.primary { background:#00675f; color:#fff; }
  .loop-legal-summary { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; margin:26px 0 8px; }
  .loop-legal-pill-card { border:1px solid rgba(207,225,222,.95); border-radius:22px; background:rgba(248,252,251,.86); padding:17px; }
  .loop-legal-pill-card strong { display:block; color:#0f172a; font-size:14px; font-weight:950; margin-bottom:6px; }
  .loop-legal-pill-card span { display:block; color:#64748b; font-size:13px; line-height:1.45; font-weight:700; }
  .loop-legal-content { margin-top:30px; display:grid; gap:24px; }
  .loop-legal-section { padding-top:24px; border-top:1px solid rgba(226,232,240,.95); }
  .loop-legal-section h2 { margin:0 0 10px; color:#0f172a; font-size:22px; line-height:1.18; font-weight:950; letter-spacing:-.035em; }
  .loop-legal-section p, .loop-legal-section li { color:#475569; font-size:15px; line-height:1.72; font-weight:650; }
  .loop-legal-section p { margin:0; }
  .loop-legal-section ul { margin:10px 0 0; padding-left:22px; }
  .loop-legal-section li + li { margin-top:7px; }
  .loop-legal-callout { margin-top:16px; border:1px solid rgba(0,103,95,.18); background:rgba(240,253,250,.82); color:#00675f; border-radius:22px; padding:16px 18px; font-size:14px; line-height:1.55; font-weight:850; }
  .loop-legal-warning { margin-top:16px; border:1px solid rgba(245,158,11,.24); background:rgba(255,251,235,.86); color:#92400e; border-radius:22px; padding:16px 18px; font-size:14px; line-height:1.55; font-weight:850; }
  .loop-legal-contact { display:inline; color:#00675f; font-weight:950; text-decoration:none; }
  .loop-legal-contact:hover { text-decoration:underline; }
  .loop-legal-note { margin-top:30px; padding:17px 19px; border-radius:22px; background:#f0fdfa; border:1px solid rgba(0,103,95,.16); color:#00675f; font-size:14px; line-height:1.5; font-weight:850; }
  @media (max-width:860px){ .loop-legal-summary{grid-template-columns:1fr;} .loop-legal-topline{display:block;} .loop-legal-version{display:inline-flex;margin-top:18px;} }
  @media (max-width:640px){ .loop-legal-page{padding:20px 12px calc(var(--loop-mobile-nav-height,72px) + 24px);} .loop-legal-card{border-radius:26px;padding:24px 18px;} .loop-legal-title{font-size:39px;letter-spacing:-.06em;} }
  @media print { .loop-legal-page{background:#fff!important;padding:0!important;} .loop-legal-card{box-shadow:none!important;border:0!important;border-radius:0!important;} .loop-legal-actions{display:none!important;} }
`;

export default function PrivacyPage() {
  return (
    <>
      <style>{legalPageStyles}</style>
      <main className="loop-legal-page">
        <div className="loop-legal-wrap">
          <section className="loop-legal-card">
            <div className="loop-legal-topline">
              <div>
                <div className="loop-legal-kicker">Privacidad</div>
                <h1 className="loop-legal-title">Política de privacidad.</h1>
                <p className="loop-legal-subtitle">Cómo Loop trata datos de clientes, negocios, trabajadores, reservas, pagos, reportes, membresías, fidelidad y comunicaciones.</p>
              </div>
              <div className="loop-legal-version">{LOOP_LEGAL_PRIVACY_VERSION}</div>
            </div>

            <div className="loop-legal-actions">
              <button type="button" className="primary" onClick={() => window.print()}>Imprimir / PDF</button>
              <button type="button" onClick={() => downloadTextFile("loop-politica-privacidad.txt", plainText())}>Descargar TXT</button>
              <a href="/terms">Términos</a>
              <a href="/privacy">Privacidad</a>
              <a href="/payments">Pagos</a>
              <a href={`mailto:${LOOP_SUPPORT_EMAIL}`}>Soporte</a>
            </div>

            <div className="loop-legal-summary">
              <div className="loop-legal-pill-card"><strong>Reservas</strong><span>Datos necesarios para confirmar, modificar, recordar y atender reservas.</span></div>
              <div className="loop-legal-pill-card"><strong>Negocios</strong><span>Herramientas de agenda, clientes, reportes, membresías, fidelidad y operaciones.</span></div>
              <div className="loop-legal-pill-card"><strong>Pagos</strong><span>Referencias, estados y conciliación sin almacenar datos completos de tarjeta.</span></div>
            </div>

            <div className="loop-legal-content">
              {SECTIONS.map((section) => (
                <div className="loop-legal-section" key={section.title}>
                  <h2>{section.title}</h2>
                  {section.body ? <p>{section.body}</p> : null}
                  {section.bullets && section.bullets.length ? <ul>{section.bullets.map((item) => <li key={item}>{item}</li>)}</ul> : null}
                  {section.callout ? <div className="loop-legal-callout">{section.callout}</div> : null}
                </div>
              ))}
            </div>
            <div className="loop-legal-note">Última actualización: {LOOP_LEGAL_UPDATED_LABEL}. Contacto oficial: <a className="loop-legal-contact" href={`mailto:${LOOP_SUPPORT_EMAIL}`}>{LOOP_SUPPORT_EMAIL}</a>.</div>
          </section>
        </div>
      </main>
    </>
  );
}
